// extracted by mini-css-extract-plugin
module.exports = {"new_cairo_hero_image":"NewCairoHeroImage_new_cairo_hero_image__6aPqn"};